import React from 'react';
import { Box, Paper } from '@mui/material';

const JSONViewer = ({ data }) => {
  let content = null;
  try {
    const ReactJson = null;
    if (ReactJson) {
      content = <ReactJson src={data || {}} name={false} collapsed={2} enableClipboard={false} displayDataTypes={false} />;
    }
  } catch (_) {}
  if (!content) {
    content = (
      <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {JSON.stringify(data || {}, null, 2)}
      </pre>
    );
  }
  return (
    <Box>
      <Paper variant="outlined" sx={{ p: 2, maxHeight: 600, overflow: 'auto' }}>
        {content}
      </Paper>
    </Box>
  );
};

export default JSONViewer;
